<template>
  <div class="user-page">
    <div class="user-banner" :style="{ backgroundImage: 'url(/user-banner-bg.png)' }">
      <div class="banner-inner"><h1>{{ $t('user.personalData') }}</h1></div>
    </div>
    <div class="user-content">
      <div class="sidebar">
        <a href="javascript:void(0)" :class="{ active: tab === 'tests' }" @click="tab = 'tests'">
          <img v-if="tab === 'tests'" class="sidebar-icon" src="/icon-tests-active.png" alt="" />
          <img v-else class="sidebar-icon" src="/icon-tests.png" alt="" />
          {{ $t('user.myTests') }}
        </a>
        <a href="javascript:void(0)" :class="{ active: tab === 'profile' }" @click="tab = 'profile'">
          <img v-if="tab === 'profile'" class="sidebar-icon" src="/icon-profile-active.png" alt="" />
          <img v-else class="sidebar-icon" src="/icon-profile.png" alt="" />
          {{ $t('user.profile') }}
        </a>
        <a href="javascript:void(0)" @click="logout">
          <img class="sidebar-icon" src="/icon-logout.png" alt="" />
          {{ $t('user.logout') }}
        </a>
      </div>
      <div class="main-area">
        <!-- 我的测试 -->
        <div v-if="tab === 'tests'">
          <div class="stat-cards">
            <div class="stat-card" :style="{ backgroundImage: 'url(/stat-card-purple.png)' }">
              <div class="stat-header"><span>{{ $t('user.currentLevel') }}</span></div>
              <div class="stat-value">{{ testData.currentLevel || '--' }}</div>
            </div>
            <div class="stat-card" :style="{ backgroundImage: 'url(/stat-card-blue.png)' }">
              <div class="stat-header"><span>{{ $t('user.totalTests') }}</span></div>
              <div class="stat-value">{{ testData.totalTests || 0 }}</div>
            </div>
            <div class="stat-card" :style="{ backgroundImage: 'url(/stat-card-cyan.png)' }">
              <div class="stat-header"><span>{{ $t('user.bestLevel') }}</span></div>
              <div class="stat-value">{{ testData.bestLevel || '--' }}</div>
              <div class="stat-sub">{{ testData.bestDate }}</div>
            </div>
          </div>
          <h3 class="section-title"><span class="title-bar"></span>{{ $t('user.testsHistory') }}</h3>
          <table class="test-table" v-if="testData.records && testData.records.length">
            <thead>
              <tr>
                <th>{{ $t('user.testDate') }}</th>
                <th>{{ $t('user.testId') }}</th>
                <th>{{ $t('user.score') }}</th>
                <th>{{ $t('user.grade') }}</th>
                <th>{{ $t('user.duration') }}</th>
                <th>{{ $t('user.status') }}</th>
                <th>{{ $t('user.report') }}</th>
                <th>{{ $t('user.action') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="r in testData.records" :key="r.id">
                <td>{{ formatDate(r.testDate) }}</td>
                <td>{{ r.testId && r.testId.length > 8 ? r.testId.slice(0, 8) + '...' : r.testId }}</td>
                <td>{{ r.score != null ? r.score : '--' }}</td>
                <td>
                  <span class="grade-badge" :class="gradeColorClass(r.grade)" v-if="r.grade && r.grade !== '--'">{{ r.grade }}</span>
                  <span v-else>--</span>
                </td>
                <td>{{ r.duration ? r.duration + ' ' + $t('user.minutes') : '--' }}</td>
                <td><span :class="statusClass(r.status)">{{ statusText(r.status) }}</span></td>
                <td><span :class="r.reportStatus === 1 ? 'tag-ok' : 'tag-pending'">{{ r.reportStatus === 1 ? $t('user.completed') : $t('user.pending') }}</span></td>
                <td class="action-cell">
                  <a href="javascript:void(0)" class="link" v-if="r.reportStatus === 1" @click="viewReport(r.testId)">
                    <img class="report-icon" src="/icon-report.png" alt="" />
                    {{ $t('user.viewReport') }}
                  </a>
<!--                  <a href="javascript:void(0)" class="link detail-link" v-if="r.status === 1" @click="viewDetail(r.testId)">-->
<!--                    <svg class="detail-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                      <path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>-->
<!--                      <rect x="9" y="3" width="6" height="4" rx="1" ry="1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>-->
<!--                      <line x1="9" y1="12" x2="15" y2="12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>-->
<!--                      <line x1="9" y1="16" x2="13" y2="16" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>-->
<!--                    </svg>-->
<!--                    测评明细-->
<!--                  </a>-->
                </td>
              </tr>
            </tbody>
          </table>
          <p class="empty" v-else>{{ $t('user.noRecords') }}</p>
        </div>

        <!-- 个人资料 -->
        <div v-if="tab === 'profile'">
          <div class="profile-header">
            <img class="avatar" src="/avatar-default.png" alt="avatar" />
            <span class="profile-name">{{ profile.username }}</span>
          </div>
          <form @submit.prevent="saveProfile" class="profile-form">
            <div class="form-row">
              <div class="form-group">
                <label><span class="required">*</span>{{ $t('user.username') }}</label>
                <input :value="profile.username" disabled />
              </div>
              <div class="form-group">
                <label><span class="required">*</span>{{ $t('user.familyName') }}</label>
                <input v-model="profile.familyName" :placeholder="$t('user.familyNamePh')" />
              </div>
            </div>
            <div class="form-row">
              <div class="form-group">
                <label><span class="required">*</span>{{ $t('user.givenName') }}</label>
                <input v-model="profile.givenName" :placeholder="$t('user.givenNamePh')" />
              </div>
              <div class="form-group">
                <label><span class="required">*</span>{{ $t('user.email') }}</label>
                <input v-model="profile.email" type="email" />
              </div>
            </div>
            <div class="form-row">
              <div class="form-group">
                <label>{{ $t('user.currentPassword') }}</label>
                <input v-model="pwd.currentPassword" type="password" />
              </div>
              <div class="form-group">
                <label>{{ $t('user.newPassword') }}</label>
                <input v-model="pwd.newPassword" type="password" />
                <p class="hint">{{ $t('user.newPasswordHint') }}</p>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group">
                <label>{{ $t('user.confirmPassword') }}</label>
                <input v-model="pwd.confirmPassword" type="password" />
              </div>
              <div class="form-group">
                <label>{{ $t('user.gender') }}</label>
                <div class="radio-group">
                  <label class="radio-label"><input type="radio" v-model="profile.gender" :value="1" /> {{ $t('user.male') }}</label>
                  <label class="radio-label"><input type="radio" v-model="profile.gender" :value="2" /> {{ $t('user.female') }}</label>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group">
                <label><span class="required">*</span>{{ $t('user.birthday') }}</label>
                <input v-model="profile.birthday" type="date" />
              </div>
              <div class="form-group">
                <label>{{ $t('user.country') }}</label>
                <div class="select-wrapper">
                  <select v-model="profile.country">
                    <option value="">{{ $t('user.countryPh') }}</option>
                    <option v-for="c in countries" :key="c" :value="c">{{ c }}</option>
                  </select>
                  <img class="select-arrow" src="/icon-arrow-down.png" alt="" />
                </div>
              </div>
            </div>
            <p class="error" v-if="profileError">{{ profileError }}</p>
            <div class="form-actions">
              <button type="submit" class="btn-save" :disabled="saving">
                {{ saving ? $t('user.saving') : $t('user.saveChanges') }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- 测评明细弹窗（在根 div 内，保证单根节点）-->
    <div class="modal-mask" v-if="detailVisible" @click.self="closeDetail">
      <div class="modal-box">
        <div class="modal-header">
          <span class="modal-title">测评明细</span>
          <button class="modal-close" @click="closeDetail">✕</button>
        </div>

        <div class="modal-loading" v-if="detailLoading">加载中...</div>

        <div class="modal-body" v-else>
          <!-- 阶段 Tab -->
          <div class="phase-tabs">
            <button
              v-for="p in detailPhases" :key="p.phase"
              :class="['phase-tab', { active: activePhase === p.phase }]"
              @click="activePhase = p.phase">
              {{ p.label }}
              <span class="phase-avg" :class="gradeColorClass(phaseGrade(p.avg))">{{ p.avg }} 分</span>
            </button>
          </div>

          <!-- 题目列表 -->
          <div class="detail-list">
            <div class="detail-item" v-for="q in currentPhaseRounds" :key="q.roundNumber">
              <span class="q-num">第 {{ q.phaseRound }} 题</span>
              <span class="q-type-badge" :class="q.answerType === 'audio' ? 'badge-audio' : 'badge-text'">
                {{ q.answerType === 'audio' ? '语音作答' : '文字作答' }}
              </span>
              <span class="q-score" :class="scoreClass(q)">
                {{ displayScore(q) !== null ? displayScore(q) + ' 分' : '未评分' }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../utils/api'

export default {
  name: 'UserCenter',
  data() {
    return {
      tab: 'tests',
      testData: { records: [], totalTests: 0, currentLevel: 0, bestLevel: 0, bestDate: '' },
      profile: {},
      pwd: { currentPassword: '', newPassword: '', confirmPassword: '' },
      profileError: '',
      saving: false,
      countries: ['China', 'United States', 'United Kingdom', 'Japan', 'Korea', 'Canada', 'Australia', 'Germany', 'France', 'Singapore', 'Malaysia', 'Thailand', 'Other'],
      detailVisible: false,
      detailLoading: false,
      detailRounds: [],
      activePhase: 1
    }
  },
  computed: {
    detailPhases() {
      var self = this
      var phases = [
        { phase: 1, label: '语音测评' },
        { phase: 2, label: '阅读测评' },
        { phase: 3, label: '写字测评' }
      ]
      return phases.map(function(p) {
        var rounds = self.detailRounds.filter(function(r) { return r.phase === p.phase })
        var scored = rounds.filter(function(r) { return self.displayScore(r) !== null })
        var avg = scored.length > 0
          ? Math.round(scored.reduce(function(a, r) { return a + self.displayScore(r) }, 0) / scored.length)
          : '--'
        return Object.assign({}, p, { avg: avg })
      })
    },
    currentPhaseRounds() {
      var phase = this.activePhase
      return this.detailRounds.filter(function(r) { return r.phase === phase })
    }
  },
  watch: {
    tab(val) {
      if (val === 'tests') this.loadTests()
      if (val === 'profile') this.loadProfile()
    }
  },
  mounted() {
    this.loadTests()
  },
  methods: {
    formatDate(val) {
      if (!val) return '--'
      var str = String(val)
      if (str.includes('T')) {
        var parts = str.split('T')
        var date = parts[0]
        var time = parts[1] ? parts[1].substring(0, 5) : ''
        return date + ' ' + time
      }
      return str
    },
    viewReport(sessionId) {
      this.$router.push({ path: '/report', query: { sessionId: sessionId } })
    },
    statusClass(status) {
      if (status === 1) return 'tag-ok'
      if (status === 2) return 'tag-abort'
      return 'tag-pending'
    },
    statusText(status) {
      if (status === 1) return this.$t('user.completed')
      if (status === 2) return this.$t('user.aborted') || '提前中止'
      return this.$t('user.inProgress') || '进行中'
    },
    async loadTests() {
      try {
        var res = await api.get('/api/user/tests')
        if (res.code === 200) this.testData = res.data
      } catch (e) { /* ignore */ }
    },
    async loadProfile() {
      try {
        var res = await api.get('/api/user/profile')
        if (res.code === 200) this.profile = res.data
      } catch (e) { /* ignore */ }
    },
    async saveProfile() {
      this.profileError = ''
      this.saving = true
      try {
        var payload = Object.assign({}, this.profile, this.pwd)
        var res = await api.put('/api/user/profile', payload)
        if (res.code === 200) {
          alert(this.$t('user.saveSuccess'))
          this.pwd = { currentPassword: '', newPassword: '', confirmPassword: '' }
        } else {
          this.profileError = res.message
        }
      } catch (e) {
        this.profileError = this.$t('user.saveFail')
      }
      this.saving = false
    },
    logout() {
      localStorage.removeItem('token')
      localStorage.removeItem('username')
      this.$router.push('/login')
    },
    gradeColorClass(grade) {
      var map = { C2: 'grade-c2', C1: 'grade-c1', B2: 'grade-b2', B1: 'grade-b1', A2: 'grade-a2', A1: 'grade-a1' }
      return map[grade] || ''
    },
    async viewDetail(sessionId) {
      this.detailVisible = true
      this.detailLoading = true
      this.detailRounds = []
      this.activePhase = 1
      try {
        var res = await api.get('/api/assessment/result/' + sessionId)
        if (res.code === 200 && res.data) {
          this.detailRounds = res.data.roundResults || []
        }
      } catch (e) { /* ignore */ }
      this.detailLoading = false
    },
    closeDetail() {
      this.detailVisible = false
    },
    displayScore(q) {
      if (q.answerType === 'text') {
        return q.llmScore != null ? Number(q.llmScore) : (q.suggestedScore != null ? Number(q.suggestedScore) : null)
      }
      return q.suggestedScore != null ? Number(q.suggestedScore) : null
    },
    scoreClass(q) {
      var s = this.displayScore(q)
      if (s === null) return 'score-none'
      if (s >= 80) return 'score-high'
      if (s >= 60) return 'score-mid'
      return 'score-low'
    },
    scoreBarColor(val) {
      if (val >= 80) return '#10b981'
      if (val >= 60) return '#f59e0b'
      return '#ef4444'
    },
    phaseGrade(avg) {
      if (avg === '--' || avg == null) return ''
      if (avg >= 80) return 'C2'
      if (avg >= 70) return 'C1'
      if (avg >= 60) return 'B2'
      if (avg >= 50) return 'B1'
      if (avg >= 40) return 'A2'
      return 'A1'
    }
  }
}
</script>

<style scoped>
.user-page { background: #f0f2f5; min-height: 100vh; }
.user-banner {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 40px 0 40px;
  height: 150px;
}
.banner-inner { max-width: 1100px; margin: 0 auto; padding: 0 40px; }
.banner-inner h1 { color: #fff; font-size: 28px; font-weight: 700; }
.user-content { max-width: 1100px; margin: -20px auto 0; padding: 0 40px 40px; display: flex; gap: 24px; position: relative; z-index: 1; }

/* Sidebar */
.sidebar { width: 220px; background: #fff; border-radius: 12px; padding: 12px 0; box-shadow: 0 2px 12px rgba(0,0,0,0.06); flex-shrink: 0; height: fit-content; }
.sidebar a {
  display: flex; align-items: center; gap: 10px;
  padding: 14px 24px; text-decoration: none;
  color: #555; font-size: 14px; font-weight: 500;
  transition: all 0.2s; border-left: 3px solid transparent;
}
.sidebar a:hover { color: #2b7de9; background: #f5f8ff; }
.sidebar a.active { color: #2b7de9; font-weight: 600; background: #eef4ff; border-left-color: #2b7de9; }
.sidebar-icon { width: 20px; height: 20px; object-fit: contain; }

/* Main */
.main-area { flex: 1; min-width: 0; }

/* Stat Cards */
.stat-cards { display: flex; gap: 16px; margin-bottom: 28px; }
.stat-card {
  flex: 1; border-radius: 12px; padding: 20px 24px;
  background-size: cover; background-position: center;
  min-height: 100px; position: relative; overflow: hidden;
}
.stat-header { font-size: 13px; color: #555; margin-bottom: 8px; }
.stat-value { font-size: 32px; font-weight: 700; color: #1a1a1a; }
.stat-sub { font-size: 12px; color: #888; margin-top: 4px; }

/* Section Title */
.section-title { font-size: 18px; font-weight: 700; color: #1a1a1a; margin-bottom: 16px; display: flex; align-items: center; gap: 8px; }
.title-bar { width: 4px; height: 18px; background: #2b7de9; border-radius: 2px; display: inline-block; }

/* Table */
.test-table { width: 100%; background: #fff; border-radius: 12px; overflow: hidden; box-shadow: 0 2px 12px rgba(0,0,0,0.06); border-collapse: collapse; }
.test-table th { background: #f7f8fc; padding: 14px 16px; font-size: 13px; color: #555; font-weight: 600; text-align: left; }
.test-table td { padding: 14px 16px; font-size: 13px; color: #333; border-top: 1px solid #f0f0f0; }
.test-table tbody tr:hover { background: #fafbfd; }
.tag-ok { color: #10b981; font-weight: 600; }
.tag-pending { color: #f59e0b; font-weight: 600; }
.tag-abort { color: #ef4444; font-weight: 600; }
.grade-badge {
  display: inline-block; background: #3B82F6; color: #fff;
  font-weight: 700; font-size: 13px; border-radius: 6px;
  padding: 2px 10px; min-width: 24px; text-align: center;
}
.grade-badge.grade-c2 { background: #7c3aed; }
.grade-badge.grade-c1 { background: #2563eb; }
.grade-badge.grade-b2 { background: #059669; }
.grade-badge.grade-b1 { background: #d97706; }
.grade-badge.grade-a2 { background: #ea580c; }
.grade-badge.grade-a1 { background: #dc2626; }
.action-cell { display: flex; flex-direction: column; gap: 6px; }
.link { color: #2b7de9; text-decoration: none; font-weight: 600; display: flex; align-items: center; gap: 4px; }
.link:hover { color: #1a6ad4; }
.detail-link { color: #7c3aed; }
.detail-link:hover { color: #5b21b6; }
.report-icon { width: 16px; height: 16px; object-fit: contain; }
.detail-icon { width: 14px; height: 14px; }
.empty { color: #999; font-size: 14px; text-align: center; padding: 40px; }

/* Profile */
.profile-header { display: flex; flex-direction: column; align-items: center; gap: 12px; padding: 32px 24px 24px; }
.avatar { width: 80px; height: 80px; border-radius: 50%; object-fit: cover; }
.profile-name { font-size: 18px; font-weight: 600; color: #1a1a1a; }
.profile-form { background: #fff; border-radius: 12px; padding: 28px 32px; box-shadow: 0 2px 12px rgba(0,0,0,0.06); }
.form-row { display: flex; gap: 24px; margin-bottom: 0; }
.form-row .form-group { flex: 1; }
.form-group { margin-bottom: 20px; }
.form-group label { display: block; font-size: 13px; color: #555; margin-bottom: 6px; font-weight: 600; }
.required { color: #ef4444; margin-right: 2px; }
.form-group input, .form-group select {
  width: 100%; padding: 10px 12px;
  border: 1px solid #ddd; border-radius: 6px;
  font-size: 14px; outline: none; box-sizing: border-box;
  background: #fff;
}
.form-group input:focus, .form-group select:focus { border-color: #2b7de9; }
.form-group input:disabled { background: #f5f5f5; color: #999; }
.hint { font-size: 12px; color: #999; margin-top: 4px; }
.radio-group { display: flex; gap: 32px; padding-top: 8px; }
.radio-label { font-size: 14px; color: #333; font-weight: 400; cursor: pointer; display: flex; align-items: center; gap: 6px; }
.radio-label input[type="radio"] { accent-color: #2b7de9; }
.select-wrapper { position: relative; }
.select-wrapper select { appearance: none; -webkit-appearance: none; padding-right: 32px; }
.select-arrow { position: absolute; right: 12px; top: 50%; transform: translateY(-50%); width: 12px; height: 12px; pointer-events: none; }
.error { color: #ef4444; font-size: 13px; margin-bottom: 12px; }
.form-actions { text-align: center; padding-top: 12px; }
.btn-save { background: #2b7de9; color: #fff; border: none; padding: 12px 48px; border-radius: 6px; font-size: 14px; font-weight: 600; cursor: pointer; }
.btn-save:hover { background: #1a6ad4; }
.btn-save:disabled { background: #93bff0; cursor: not-allowed; }

@media (max-width: 768px) {
  .user-content { flex-direction: column; padding: 0 16px 24px; }
  .sidebar { width: 100%; }
  .stat-cards { flex-direction: column; }
  .banner-inner { padding: 0 16px; }
  .form-row { flex-direction: column; gap: 0; }
}

/* ===== 测评明细弹窗 ===== */
.modal-mask {
  position: fixed; inset: 0; z-index: 9999;
  background: rgba(0,0,0,0.45);
  display: flex; align-items: center; justify-content: center;
}
.modal-box {
  background: #fff; border-radius: 16px;
  width: 720px; max-width: 96vw; max-height: 88vh;
  display: flex; flex-direction: column;
  box-shadow: 0 8px 40px rgba(0,0,0,0.18); overflow: hidden;
}
.modal-header {
  display: flex; align-items: center; justify-content: space-between;
  padding: 20px 28px 16px; border-bottom: 1px solid #f0f0f0; flex-shrink: 0;
}
.modal-title { font-size: 17px; font-weight: 700; color: #1a1a1a; }
.modal-close { background: none; border: none; font-size: 18px; color: #999; cursor: pointer; padding: 0 4px; line-height: 1; }
.modal-close:hover { color: #333; }
.modal-loading { padding: 60px; text-align: center; color: #999; font-size: 14px; }
.modal-body { overflow-y: auto; flex: 1; padding: 0 0 20px; }

/* 阶段 Tab */
.phase-tabs { display: flex; border-bottom: 1px solid #f0f0f0; padding: 0 28px; }
.phase-tab {
  background: none; border: none; cursor: pointer;
  padding: 14px 20px 12px; font-size: 14px; font-weight: 500; color: #666;
  border-bottom: 3px solid transparent;
  display: flex; align-items: center; gap: 8px; transition: all 0.2s;
}
.phase-tab:hover { color: #2b7de9; }
.phase-tab.active { color: #2b7de9; font-weight: 700; border-bottom-color: #2b7de9; }
.phase-avg { font-size: 12px; font-weight: 700; padding: 1px 7px; border-radius: 10px; color: #fff; background: #94a3b8; }
.phase-avg.grade-c2 { background: #7c3aed; }
.phase-avg.grade-c1 { background: #2563eb; }
.phase-avg.grade-b2 { background: #059669; }
.phase-avg.grade-b1 { background: #d97706; }
.phase-avg.grade-a2 { background: #ea580c; }
.phase-avg.grade-a1 { background: #dc2626; }

/* 题目明细列表 */
.detail-list { padding: 20px 28px 0; display: flex; flex-direction: column; gap: 10px; }
.detail-item { display: flex; align-items: center; gap: 12px; border: 1px solid #e5e7eb; border-radius: 10px; padding: 14px 20px; background: #fafbfd; }
.detail-item-header { display: flex; align-items: center; gap: 10px; }
.q-num { font-size: 14px; font-weight: 700; color: #1a1a1a; }
.q-type-badge { font-size: 11px; font-weight: 600; padding: 2px 8px; border-radius: 10px; }
.badge-audio { background: #dbeafe; color: #1d4ed8; }
.badge-text { background: #d1fae5; color: #065f46; }
.q-score { margin-left: auto; font-size: 15px; font-weight: 800; }
.score-high { color: #10b981; }
.score-mid { color: #f59e0b; }
.score-low { color: #ef4444; }
.score-none { color: #aaa; font-size: 13px; font-weight: 500; }
.field-label {
  display: inline-block; font-size: 11px; font-weight: 700;
  color: #2b7de9; background: #eff6ff; padding: 1px 8px;
  border-radius: 4px; margin-bottom: 6px;
}
.detail-scenario p, .detail-question p, .detail-answer p, .detail-feedback p {
  font-size: 13px; color: #444; line-height: 1.7; margin: 0 0 10px;
}
.detail-feedback p { color: #6b7280; font-style: italic; }
.detail-no-score { font-size: 13px; color: #bbb; padding: 8px 0; }

/* 发音指标条 */
.detail-metrics { display: flex; flex-direction: column; gap: 8px; margin-top: 4px; }
.metric { display: flex; align-items: center; gap: 10px; }
.metric-label { font-size: 12px; color: #666; width: 72px; flex-shrink: 0; }
.metric-bar-wrap { flex: 1; height: 8px; background: #e5e7eb; border-radius: 4px; overflow: hidden; }
.metric-bar { height: 100%; border-radius: 4px; transition: width 0.4s; }
.metric-val { font-size: 13px; font-weight: 700; color: #333; width: 28px; text-align: right; flex-shrink: 0; }
</style>
